import script from "./ProductionUpdateControl.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductionUpdateControl.vue?vue&type=script&setup=true&lang=ts"

import "./ProductionUpdateControl.vue?vue&type=style&index=0&id=eeb50088&scoped=true&lang=css"

import exportComponent from "../../../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eeb50088"]])

export default __exports__